export default function anonymous(context
) {
var out='';if(context.end === undefined){ context.end = '\n'; }if(context.object.matchCount > 0){if(context.object.isWildcardMatch ||context.object.matchCount > 1){out+=''+( context.object.matchCount )+' ';}out+=''+( context.object.name )+( context.end );}return out;
}